import React, { useState } from 'react';
import styles from './index.module.scss';

const PRIVACY_POLICY_LINK = 'https://www.pmiprivacy.com/ukraine/uk/consumer/';

const ConsentBannerScreen = ({ children, onAcceptAll, onLearnMore }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.background}>{children}</div>
      <div className={styles.banner}>
        <span className={styles.handle} />
        <p className={styles.text}>
          Ми використовуємо файли cookie та подібні технології для надання
          персоналізованого досвіду (відповідно до вашої поведінки в Інтернеті
          на цьому та інших веб-сайтах)
          {isExpanded ? (
            <>
              , для релевантного відображення оголошень, контенту і доречної
              комунікації; для поліпшення сайту; роботи сайту; і щоб пам'ятати
              ваші уподобання. Натисніть «Дізнатися більше» для отримання
              додаткової інформації або для налаштування параметрів. Ви можете
              змінити свою думку в будь-який час, відвідавши «Налаштування
              файлів cookie». Будь-які ваші персональні дані будуть
              використовуватися, як описано в нашій{' '}
              <a
                className={styles.policyLink}
                href={PRIVACY_POLICY_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                Політиці конфіденційності
              </a>
              .
            </>
          ) : (
            <>
              .{' '}
              <button
                type="button"
                className={styles.moreButton}
                onClick={() => setIsExpanded(true)}
              >
                Детальніше
              </button>
            </>
          )}
        </p>
        <button
          type="button"
          className={styles.acceptButton}
          onClick={onAcceptAll}
        >
          Погоджуюся з усім
        </button>
        <button
          type="button"
          className={styles.learnMoreButton}
          onClick={onLearnMore}
        >
          Дізнатися більше
        </button>
      </div>
    </div>
  );
};

export default ConsentBannerScreen;
